/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsAUpIcon16Solid = forwardRef('DataChartBarsAUpIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M13 4a1 1 0 1 0-2 0v9a1 1 0 1 0 2 0V4Z" }),
        React.createElement("path", { d: "M9 5a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0V6a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M7 8a1 1 0 0 0-2 0v5a1 1 0 1 0 2 0V8Z" }),
        React.createElement("path", { d: "M4 10a1 1 0 0 0-2 0v3a1 1 0 1 0 2 0v-3Z" })));
});
